import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, State } from './general.reducer';

export const selectProjectState = createFeatureSelector<State>(featureKey);

export const getVehicleSelection = createSelector(selectProjectState, (state: State) => state.vehicleSelection);
export const getUploadedImage = createSelector(selectProjectState, (state: State) => state.uploadedImage);
export const getBrand = createSelector(selectProjectState, (state: State) => state.brand);
export const getManufactureYear = createSelector(selectProjectState, (state: State) => state.manufactureYear);
export const getModel = createSelector(selectProjectState, (state: State) => state.model);
export const getFuel = createSelector(selectProjectState, (state: State) => state.fuel);
export const getCarType = createSelector(selectProjectState, (state: State) => state.carType);
export const getHorsePower = createSelector(selectProjectState, (state: State) => state.horsePower);
export const getPossibleVehicles = createSelector(selectProjectState, (state: State) => state.possibleVehicles);
export const getSelectedVehicle = createSelector(selectProjectState, (state: State) => state.selectedVehicle);
export const getPrevUrl = createSelector(selectProjectState, (state: State) => state.prevUrl);
export const getInsurerTakerCategory = createSelector(selectProjectState, (state: State) => state.insurerTakerCategory);
export const getOtherVehicles = createSelector(selectProjectState, (state: State) => state.otherVehicles);
export const getPriceInfo = createSelector(selectProjectState, (state: State) => state.priceInfo);
export const getBankAccountHolderAuthorization = createSelector(
  selectProjectState,
  (state: State) => state.bankAccountHolderAuthorization
);
export const getVehicleOwnerCategory = createSelector(selectProjectState, (state: State) => state.vehicleOwnerCategory);
export const getBankAccountHolderCategory = createSelector(
  selectProjectState,
  (state: State) => state.bankAccountHolderCategory
);
export const getPreviousInsuranceFinish = createSelector(
  selectProjectState,
  (state: State) => state.previousInsuranceFinish
);
export const getHasPreviousClaims = createSelector(selectProjectState, (state: State) => state.hasPreviousClaims);
export const getGapSelection = createSelector(selectProjectState, (state: State) => state.gapSelection);
export const getPostcode = createSelector(selectProjectState, (state: State) => state.postcode);
export const getDeductibleOptions = createSelector(selectProjectState, (state: State) => state.deductibleOptions);
export const getPaymentMethods = createSelector(selectProjectState, (state: State) => state.paymentMethods);
export const getProgressId = createSelector(selectProjectState, (state: State) => state.progressId);
export const getFullOperationId = createSelector(selectProjectState, (state: State) => state.fullOperationId);
export const getInsuranceModalitiesOffered = createSelector(
  selectProjectState,
  (state: State) => state.insuranceModalitiesOffered
);
export const getInsurancePricesOffered = createSelector(
  selectProjectState,
  (state: State) => state.insurancePricesOffered
);
export const getPreviousInsuranceBrand = createSelector(
  selectProjectState,
  (state: State) => state.previousInsuranceBrand
);
export const getDefaultPrice = createSelector(selectProjectState, (state: State) => state.defaultPrice);
export const getAddonNamesSelected = createSelector(selectProjectState, (state: State) => state.addonNamesSelected);
export const getAddonPricesSelected = createSelector(selectProjectState, (state: State) => state.addonPricesSelected);
export const getAnalyticBrand = createSelector(selectProjectState, (state: State) => state.analyticBrand);
export const getAnalyticModel = createSelector(selectProjectState, (state: State) => state.analyticModel);
export const getReferralCodeUrl = createSelector(selectProjectState, (state: State) => state.referralCodeUrl);
export const getLastPromotionCodeValidated = createSelector(
  selectProjectState,
  (state: State) => state.lastPromotionCodeValidated
);
export const getVehicleDoors = createSelector(selectProjectState, (state: State) => state.vehicleDoors);
export const getRecommendations = createSelector(selectProjectState, (state: State) => state.recommendations);
export const getQuotation = createSelector(selectProjectState, (state: State) => state.quotation);
export const getCarInsurers = createSelector(selectProjectState, (state: State) => state.carInsurers);
